export const API_URL = 'https://api.sportbeagle.com/' 
export const GOOGLE_ID = '612878331716-9htsapc71tr5stl90hbaurbkh7ak1uef.apps.googleusercontent.com' 
export const FB_ID = '1149698593484172' 